import { lazy } from 'react'

import {
  ROUTE_PATH_LIST,
  ROUTE_PATH_LIST_RENTAL_PORTAL,
} from '../../constants/route'
import { EmailSubMenu } from '../Email'
import { IdwellToIdwellSubMenu } from '../IdwellToIdwell'

const RentalPortalSubMenu = lazy(() =>
  import('../RentalPortal').then(module => ({
    default: module.RentalPortalSubMenu,
  }))
)

export const SUB_MENU_COMPONENT = {
  [ROUTE_PATH_LIST.idwellToIdwell]: IdwellToIdwellSubMenu,
  [ROUTE_PATH_LIST.mails]: EmailSubMenu,
  [ROUTE_PATH_LIST_RENTAL_PORTAL.root]: RentalPortalSubMenu,
}
